<script setup>
import '@/assets/cloudCounter/css/style.css';
import { ref, defineProps, computed, watch, onMounted } from 'vue';

import Layout from '@/components/cloudCounter/Layout.vue';
import Process from '@/components/cloudCounter/Process.vue';
import CaseBox from '@/components/cloudCounter/CaseBox.vue';
import SelectBoxV2 from '@/components/cloudCounter/SelectBox.v2.vue';
import InputBankAccount from '@/components/cloudCounter/InputBankAccount.vue';
import InputPercentage from '@/components/cloudCounter/InputPercentage.vue';
import SortableBox from '@/components/cloudCounter/SortableBox.vue';
import Calendar from '@/components/cloudCounter/Calendar.vue';

import { useRouter } from 'vue-router';
const router = useRouter();



function toChineseNumber(n) {
    if (!Number.isInteger(n) && n < 0) {
        throw Error('请输入自然数');
    }

    const digits = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
    const positions = ['', '十', '百', '千', '万', '十万', '百万', '千万', '亿', '十亿', '百亿', '千亿'];
    const charArray = String(n).split('');
    let result = '';
    let prevIsZero = false;
    //处理0  deal zero
    for (let i = 0; i < charArray.length; i++) {
        const ch = charArray[i];
        if (ch !== '0' && !prevIsZero) {
            result += digits[parseInt(ch)] + positions[charArray.length - i - 1];
        } else if (ch === '0') {
            prevIsZero = true;
        } else if (ch !== '0' && prevIsZero) {
            result += '零' + digits[parseInt(ch)] + positions[charArray.length - i - 1];
        }
    }
    //处理十 deal ten
    if (n < 100) {
        result = result.replace('一十', '十');
    }
    return result;
}


const typeIndex = ref(0);  //保險金類別 index
const setTypeIndex = (i) => {
    typeIndex.value = i;
};

//收益人資料
const benefitsList = ref([
    {
        title: '生存保險金',
        order: [
            // {
            //     title: '第一順位',
            //     isEqual: false,  //均分
            //     order:[          //同順位
            //         {
            //             isComplete: false    //此人是否完成所有欄位填寫
            //             isOpen: true,        //資料展開
            //             fields:[]            //單人資料表單項目
            //         }
            //     ]        
            //         
            // },
            // {
            //     title: '第二順位',
            //     isEqual: false,  //均分
            //     order:[]         //同順位
            // },
        ],
    },
    // {
    //     title: '滿期保險金',
    //     order: [
    //         //  ...
    //     ],
    // },
    // {
    //     title: '身故保險金',
    //     order: [
    //         //  ...
    //     ],
    // },
]);


//單收益人欄位(新增收益人用)
const singleData = JSON.stringify({
    isComplete: false,
    isOpen: true,
    fields:
        [
            {
                "id": "name",
                "name": "姓名",
                "key": "姓名",
                "placeholder": "請填寫姓名",
                "value": "",
                "CheckVisible": false
            },
            {
                "id": "id",
                "name": "身分證字號",
                "key": "身分證字號",
                "placeholder": "請輸入身分證字號",
                "value": ""
            },
            {
                "id": "country",
                "name": "國籍",
                "key": "國籍",
                "value": "中華民國",
                "disabled": true
            },
            {
                "id": "birthday",
                "name": "出生日期",
                "key": "出生日期",
                "placeholder": "選擇出生日期",
                "type": "calendar",
                "value": "",
                "minDate": "50/9/6",
                "maxDate": "200/9/6",
                "beginDate": "",
                "isYearROC": true,
                "isOpenCalendar": false,
            },
            {
                "id": "relation",
                "name": "與被保險人的關係",
                "key": "與被保險人的關係",
                "placeholder": "請選擇與被保險人的關係",
                "type": "select",
                "options": [
                    "祖父母",
                    "外祖父母",
                    "父母親",
                    "子女"
                ],
                "value": ""
            },
            {
                "id": "account",
                "name": "受益人匯款帳號 (非必填)",
                "key": "受益人匯款帳號",
                "type": "bankAccount",
                "value": {
                    "bankCode": "",
                    "bankBranch": "",
                    "bankAccount": ""
                }
            },
            {
                "id": "ratio",
                "name": "分配比例",
                "key": "受益人分配比例",
                "placeholder": "請填寫分配比例",
                "value": "0%",
                "isVisible": false
            },
        ]
});

const orderIndex = ref(0);  //第N順位受益人
const setOrderIndex = (index) => {
    orderIndex.value = index;
}

//新增受益人順位
const addBeneficiaryOrder = () => {
    const orderList = currentTypeOrderList.value;
    const _singleData = JSON.parse(singleData);

    _singleData.fields.forEach((item) => {
        if (item.id === 'ratio') {
            item.value = '100%';
        }
    });

    orderList.push({
        title: '第' + toChineseNumber((orderList.length + 1)) + '順位',
        isEqual: false,              //均等的
        order: [_singleData]         //同順位
    });

    orderIndex.value = orderList.length - 1;
}


//保險金種類
const currentTypeData = computed(() => benefitsList.value[typeIndex.value]);
const currentTypeOrderList = computed(() => currentTypeData.value.order);

//第N順位受益人
const currentOrderData = computed(() => ((currentTypeOrderList.value)[orderIndex.value]));

//同順位受益人清單
const sameOrderList = computed(() => ((currentOrderData.value)?.order));

//新增同順位受益人
const addSameOrder = (e) => {
    const _singleData = JSON.parse(singleData);
    sameOrderList.value.push(_singleData);
};


const setItem = (data, id, value) => {
    if (data) {
        data.forEach((item) => {
            if (item.id === id) {
                // console.log('object');
                item.value = value;
            }
        });
    }
};

const getItem = (data, id) => (data.find((item) => item.id === id)?.value || '');
const getItemRatio = (data) => (getItem(data, 'ratio'));
// const getItemOpen = (data) => (getItem(data, 'open'));


// 更新名稱、分配比例、濾掉同順位空陣列
const updateList = (_ary) => {
    if (_ary && _ary.length > 0) {

        let hasRemove = false;
        _ary.forEach((item, i, arr) => {

            if (item.order?.length <= 0) {              // 判斷同順位無受益人，移除此順位
                arr.splice(i, 1);
                hasRemove = true;
            }
            else if (item.order?.length === 1) {        // 判斷同順位只有一位受益人
                item.isEqual = false;                   // 取消均分
                setItem(item.order[0].fields, 'ratio', '100%');
            }
            else {
                if (item.isEqual) {                     // 判斷已勾選均分
                    item.order.forEach(personal => {
                        setItem(personal.fields, 'ratio', '均分');
                    });
                }
            }

        });

        if (hasRemove) {
            //更新順位
            _ary.forEach((item, i) => {
                item.title = '第' + toChineseNumber(i + 1) + '順位';
            });
        }

    }
};

// 移除受益人自己
const removeSameOrderSelf = (index, scrollToHandle) => {
    if (index >= 0) {

        (sameOrderList.value).splice(index, 1);

        if (sameOrderList.value.length === 0) {
            const newOrderIndex = (orderIndex.value) - 1;
            orderIndex.value = (newOrderIndex <= 0) ? 0 : newOrderIndex;
        }

        // 更新
        updateList(currentTypeData.value.order);

        if (typeof scrollToHandle === 'function') {
            scrollToHandle(0, 260);
        }

    }
};


//加總未符合100%
const isErrorRatio = computed(() => {
    let sum = 0;
    (sameOrderList.value).forEach(data => {
        sum += parseInt(getItemRatio(data.fields));
    });
    return (sum !== 100);
});


//平均分配
const changeCheckboxEqual = (e) => {
    sameOrderList.value.forEach(item => {
        setItem(item.fields, 'ratio', (e.target.checked) ? '均分' : '');
    });
}

//檢查項目是否完成
const checkComplete = (data) => {
    if (data) {
        let _isComplete = true;
        for (let i = 0; i < data.fields.length; i++) {
            const item = data.fields[i];
            if (item.isVisible !== false) {

                const _val = item.value;
                const isObjectEmpty = typeof _val === 'object' && (_val.bankCode === '' || _val.bankBranch === '' || _val.bankAccount === '');
                const isStringEmpty = typeof _val === 'string' && (_val === '');

                if (isObjectEmpty || isStringEmpty) {
                    _isComplete = false;
                    break;
                }
            }
        }
        // console.log(_isComplete);
        data.isComplete = _isComplete;
    }
}

//文字彈窗
const infoBoxVisible = ref(false);



const goNextPage = () => {
    router.push({ name: 'cloudCounter-update-beneficiary-update-beneficiary-check', });
    // query: { benefitsList: encodeURIComponent(JSON.stringify(benefitsList.value)) }
};

const isDisabledNextPage = computed(() => {
    let isOK = true;
    for (const typeData of benefitsList.value) {                //保險類別
        if (typeData.order.length === 0) {
            isOK = false;
            break;
        } else {
            for (const orderData of typeData.order) {           //第N順位  
                for (const personalData of orderData.order) {   //同順位
                    for (const field of personalData.fields) {  //檢查每一項欄位
                        if (
                            (typeof field.value === 'string' && field.value === '') ||
                            (typeof field.value === 'object' && (Object.values(field.value).some(x => x === '')))
                        ) {
                            isOK = false;
                            break;
                        }
                    }
                }
            }
        }
    }
    return !isOK;
});

/*
    benefitsList = ref([
    {
        title: '生存保險金',
        order: [
            // {
            //     title: '第一順位',
            //     isEqual: false,  //均分
            //     order:[          //同順位
            //         {
            //             isComplete: false    //此人是否完成所有欄位填寫
            //             fields:[]            //單人資料表單項目
            //         }
            //     ]        
            //         
            // },
            // {
            //     title: '第二順位',
            //     isEqual: false,  //均分
            //     order:[]         //同順位
            // },
        ],
    }
*/

</script>

<template>

    <SortableBox :data="currentTypeOrderList" :setData="(data) => { currentTypeData.order = data }"
        :infoBoxVisible="infoBoxVisible" infoBoxTitle="調整受益人順位" :infoBoxCloseHandle="(e) => { infoBoxVisible = false; }"
        :methods="{ toChineseNumber, setOrderIndex, updateList, }" v-if="infoBoxVisible" />

    <Layout :header="{ text: '受益人變更', backBtn: { visible: true }, closeBtn: { visible: false, to: {} }, }">

        <template #top>
            <div class="w-full max-w-3xl mx-auto p-5">
                <div class="pt-2 pb-6">
                    <Process :steps="['選擇保單', '填寫內容', '確認資料', '手機驗證',]" :index="1"></Process>
                </div>

                <h2 class="font-bold text-2xl pb-4">
                    <template v-if="benefitsList?.length === 1">填寫{{ benefitsList[0].title }}受益人資料</template>
                    <template v-else>填寫受益人資料</template>
                </h2>
            </div>

            <!-- 保險金類別頁籤 -->
            <div class="pb-8" v-if="benefitsList?.length > 1">
                <div class="border-b">
                    <div class="tabs flex max-w-3xl mx-auto px-4">
                        <button @click="(e) => { setTypeIndex(i); }" class="tabs__btn py-3 flex-1 relative"
                            :class="{ 'font-bold after:content-[\'\'] after:block after:w-full after:h-[4px] after:absolute after:bottom-0 after:rounded-md after:bg-[#0093C1]': typeIndex === i }"
                            v-for="(item, i) in benefitsList" :key="i">
                            {{ item.title }}
                        </button>
                    </div>
                </div>
            </div>
        </template>

        <template #default="layoutProps">

            <div class="pb-4 flex justify-between items-center">
                <h3 class="text-xl font-bold">受益人資料</h3>
                <div class=" text-[#0093C1] textsm">
                    <button @click="(e) => { infoBoxVisible = true; }">
                        <svg class="inline-block mb-1" width="12" height="10" viewBox="0 0 12 10" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.666748 5H11.3334M0.666748 9H11.3334M0.666748 1H11.3334" stroke="#0093C1"
                                stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        調整順位
                    </button>
                </div>
            </div>

            <p class="pb-4">
                受益人變更請依順位填寫，若同一順位有 2 位 (含) 以上，請填寫分配比例 (%)
            </p>

            <div class="pb-4 text-nowrap overflow-x-auto -mx-5 px-5">
                <button class="px-4 py-2 mr-2  text-sm rounded-full" v-for="(item, i) in currentTypeOrderList"
                    @click="(e) => { setOrderIndex(i); }"
                    :class="(orderIndex === i) ? 'text-white bg-[#0093C1]' : 'bg-[#D7D8DA]'">
                    {{ item.title }}受益人
                </button>
                <button class="px-4 py-2 text-[#0093C1] bg-[#CCF3FF] text-sm rounded-full" @click="addBeneficiaryOrder">
                    <svg class="inline-block align-middle" width="16" height="16" viewBox="0 0 16 16" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M8 2V14.0001" stroke="#0093C1" stroke-width="1.3" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path d="M14 8H1.99989" stroke="#0093C1" stroke-width="1.3" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                    編輯按鈕
                </button>
            </div>

            <!-- {{ benefitsList }} -->

            <template v-if="sameOrderList"><!-- 第N順位 -->
                <div class="mb-8">
                    <CaseBox>
                        <!-- 第N順位 同順位N個繼承人 -->
                        <div v-for="(item, i) in sameOrderList" :class="{ 'border-t mt-4 pt-4': i !== 0 }">

                            <button class="w-full flex justify-between"
                                @click="(e) => { item.isOpen = !(item.isOpen) }">
                                <div>
                                    <h5 class="inline-block pr-4 font-bold text-lg">
                                        {{ item.fields.find((item) => item.id === 'name')?.value || '受益人' +
            toChineseNumber(i + 1) }}
                                    </h5>
                                    <span class="inline-block py-1 px-2 text-sm text-[#00A59B] bg-[#DFF2F1] rounded-md"
                                        v-show="item.isComplete">填寫完成</span>
                                </div>

                                <div>
                                    <div class="px-2" :class="{ 'rotate-180': !item.isOpen }">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path d="M19 15L12 8L5 15" stroke="#0093C1" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                </div>
                            </button>

                            <div v-show="item.isOpen">

                                <ul class="list pt-6">
                                    <li v-for="field in (item.fields.filter((x) => x.isVisible !== false))">
                                        <h5 class="list__item__title">{{ field.name }}</h5>

                                        <template v-if="field.type === 'select'">
                                            <SelectBoxV2 :selectOptions="{
            selectValue: field.value,
            setValue: (data) => { field.value = data },
            placeholder: field.placeholder,
            boxData: { boxTitle: field.name, options: field.options, }
        }" :changeHandel="() => { checkComplete(item); }" />
                                        </template>
                                        <template v-else-if="field.type === 'bankAccount'">
                                            <InputBankAccount :value="field.value"
                                                :changeHandel="() => { checkComplete(item); }" />
                                        </template>
                                        <template v-else-if="field.type === 'calendar'">

                                            <div class="flex justify-between p-3 w-full border rounded-md cursor-pointer bg-white"
                                                @click="(e) => { field.isOpenCalendar = true; }">
                                                <div class="flex-1">
                                                    <template v-if="field.value">
                                                        {{ field.value }}
                                                    </template>
                                                    <template v-else>{{ field.placeholder || '-' }}</template>
                                                </div>
                                                <div>
                                                    <svg fill="#0093C1" xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 24 24" style="width: 24px; height: 24px;">
                                                        <title>chevron-down</title>
                                                        <path
                                                            d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z" />
                                                    </svg>
                                                </div>
                                            </div>

                                            <Calendar :maxDate="field.maxDate" :minDate="field.minDate"
                                                :beginDate="field.beginDate" v-model:visiblePopup="field.isOpenCalendar"
                                                v-model:userDate="field.value" :isYearROC="field.isYearROC"
                                                :boxTitle="field.placeholder" />

                                        </template>
                                        <template v-else>
                                            <input :type="field.type || 'text'" :placeholder="field.placeholder"
                                                v-model="field.value" :disabled="field.disabled"
                                                @input="(e) => { checkComplete(item); }" />
                                        </template>
                                    </li>
                                </ul>

                                <div class="text-center pt-2">
                                    <button class="pt-4 pb-2 text-[#EB4751] text-sm"
                                        @click="(e) => { removeSameOrderSelf(i, layoutProps.method.goLayoutTop); }">
                                        刪除受益人
                                    </button>
                                </div>

                            </div>

                        </div>
                    </CaseBox>

                    <button class="w-full py-4 bg-[#CCF3FF] text-[#0093C1] rounded-md" @click="addSameOrder"
                        v-if="sameOrderList.length > 0">
                        <svg class="inline-block" width="25" height="24" viewBox="0 0 25 24" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12.5" cy="12" r="10" fill="#0093C1" />
                            <path d="M12.5 7.5V16.4999" stroke="white" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M17 12H8.00009" stroke="white" stroke-width="1.95" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                        新增同順位受益人
                    </button>
                </div>
                <div class="mb-8">
                    <h3 class="pb-2 text-xl font-bold ">第{{ toChineseNumber(orderIndex + 1) }}順位受益人分配比例</h3>
                    <p class="pb-4 text-sm">所有受益比例相加需為 100%</p>
                    <CaseBox>

                        <div class="pb-4">
                            <label>
                                <input class="align-middle" type="checkbox" v-model="currentOrderData.isEqual"
                                    @change="changeCheckboxEqual" :disabled="sameOrderList.length === 1" />
                                依人數均分
                            </label>
                        </div>

                        <ul>
                            <li :class="{ 'pt-4': i !== 0 }" v-for="(item, i) in sameOrderList">
                                <h5 class="font-bold pb-2">
                                    {{ item.fields.find((item) => item.id === 'name')?.value || '受益人' +
            toChineseNumber(i
                + 1) }}
                                </h5>

                                <InputPercentage :value="getItemRatio(item.fields)"
                                    :setValue="(value) => { setItem(item.fields, 'ratio', value) }"
                                    :disabled="(sameOrderList.length === 1) || currentOrderData.isEqual"
                                    :error="(currentOrderData.isEqual) ? false : isErrorRatio">
                                </InputPercentage>

                            </li>
                        </ul>

                    </CaseBox>
                </div>
            </template>


            <ul class="text-sm text-[#86878F] list-disc pl-6">
                <li>依契約條款約定，無該項保險金時，雖於受益人欄位填寫受益人姓名仍不生效力。</li>
                <li>本人（要保人）已知悉上述身故保險金受益人如係以身份別指定（如：法定繼承人）或本人不同意填寫受益人之聯絡地址及電話之情形，則以本人最後留存之聯絡方式，作為日後受益人之通知依據。 </li>
            </ul>
        </template>

        <template #bottom>
            <button
                class="w-full pt-5 pb-14 text-center bg-[#0093C1] text-white disabled:bg-[#D7D8DA] disabled:text-[#86878F]"
                :disabled="isDisabledNextPage" @click="goNextPage">下一步</button>
        </template>

    </Layout>

</template>

<style scoped></style>
